import { useState, useEffect } from 'react'

/**
 * useDebouncedValue
 * Returns a debounced version of a changing value.
 * @param {*} value - The input value to debounce
 * @param {number} delay - Delay in ms (default 300)
 * @returns {*} debouncedValue
 */
export const useDebouncedValue = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(handler)
  }, [value, delay])

  return debouncedValue
}

export default useDebouncedValue
